<template>
  <transition>
    <div class="f-top" v-show="visible">
      <div class="top_nav">
        <a
          class="logo"
          href="/"
          bg-url="@/mobile/assets/image/logo.png"
          v-bg
        ></a>

        <ul class="nav_list">
          <li>
            <a href="https://www.flyme.com/aios/" target="_blank">Flyme AIOS</a>
          </li>
          <li>
            <a href="https://open.flymeauto.com" target="_blank">无界智行</a>
          </li>
        </ul>
      </div>
      <div class="top_nav">
        <div
          v-for="nav in navigationList"
          :key="nav.id"
          class="nav_item"
          :class="activeId === nav.id && 'nav_item_active'"
          @click="onNav(nav.id)"
        >
          {{ nav.text }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { scrollHandle } from '../bus_key'
import { getScrollTop } from '@/utils'

export default {
  name: 'topNav',
  data() {
    return {
      visible: true,
      activeId: 'home',
      clickScroll: false, // 添加点击滚动标志
      navigationList: [
        { id: 'home', text: '首页' },
        { id: 'beauty', offset: 100, text: '美' },
        { id: 'wisdom', offset: 100, text: '智' },
        { id: 'newborn', offset: 100, text: '新生' },
      ],
    }
  },

  mounted() {
    let scrollTop = 0

    this.$event.on(scrollHandle, () => {
      if (!this.clickScroll) {
        const curTop = getScrollTop()
        // 判断是否往下滚动
        if (curTop < scrollTop || curTop === 0) {
          this.visible = true
        } else {
          this.visible = false
        }
        // 更新上一次滚动位置
        scrollTop = curTop

        // 检测当前激活的section
        this.navigationList.forEach((nav) => {
          const target = document.getElementById(nav.id)
          if (target) {
            const rect = target.getBoundingClientRect()
            const offset = nav.offset || 0 // 使用 nav.offset，如果没有定义则默认为 0
            if (
              offset - rect.top >= 0 &&
              rect.top - offset < window.innerHeight
            ) {
              this.activeId = nav.id
            }
          }
        })
      }
    })
  },

  methods: {
    onNav(id) {
      this.activeId = id
      this.clickScroll = true // 设置点击滚动标志
      const target = document.getElementById(id)
      if (target) {
        const targetPosition = target.offsetTop // 获取目标元素距离页面顶部的偏移量
        window.scrollTo({ top: targetPosition, behavior: 'instant' }) // 平滑滚动
        // 滚动完成后清除标志，允许正常的滚动检测
        setTimeout(() => {
          this.clickScroll = false
        }, 100)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.f-top {
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  max-width: 1000px;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(0.6rem);
  box-sizing: border-box;
}
.top_nav {
  height: 0.92rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  margin-left: 0.48rem;
  width: 1.73rem;
  height: 0.4rem;
  background-repeat: no-repeat;
  background-size: 100%;
}

.nav_list {
  display: flex;
  justify-content: space-between;
  height: 100%;
  margin: 0;
  padding: 0;
}
.nav_item {
  font-size: clamp(16px, 0.2rem, 20px);
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff80;
  width: 100%;
  height: 100%;
}

.nav_item_active {
  color: #fff;
}
li {
  margin-right: 0.48rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

a {
  text-decoration: none;
  font-weight: 400;
  font-size: clamp(12px, 0.12rem, 18px);
  line-height: 0.25rem;
  color: rgba(255, 255, 255, 0.8);

  &:hover {
    color: #fff;
  }
}

@media screen and (max-width: 374px) {
  .open_plate {
    display: none;
  }
}
</style>
